import React from 'react'
import styled from 'styled-components'
import { CurrencySymbolImage } from './CurrencySymbolImage'

interface Props {
  className?: string
  currencySymbol: string
  otherSymbol: string
}

export function PairImage({ className, currencySymbol, otherSymbol }: Props) {
  return (
    <Content className={className}>
      <FirstCurrencyImage symbol={currencySymbol} />
      <SecondCurrencyImage symbol={otherSymbol} />
    </Content>
  )
}

const Content = styled.div`
  line-height: 0;
`

const FirstCurrencyImage = styled(CurrencySymbolImage)`
  z-index: 1;
`

const SecondCurrencyImage = styled(CurrencySymbolImage)`
  margin: 0 5px 0 -5px;
`
